











import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosTitular extends Vue {
    get titular () {
        return this.$store.state.cotacao.titular;
    }

    set titular ( value ) {
        this.$store.commit("SET_TITULAR", value);
    }

    get errorTitular () {
        return this.$store.state.errors.titular;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
